import {useCallback, useEffect, useState} from "react";
import {values, groupBy, map} from "lodash";
import {routeCommentModelData, stopCommentModelData} from "../services/ModelService";
import {useAppContext} from "../libs/contextLib";
import {roundToPrecision} from "../libs/formatLib";
import {LATLON_PRECISION} from "../libs/mapLib";

export const newestFirst = (a, b) => {
    let aCreatedAt = a.createdAt;
    let bCreatedAt = b.createdAt;

    if (Array.isArray(a)) {
        aCreatedAt = a[0].createdAt;
        bCreatedAt = b[0].createdAt;
    }
    return aCreatedAt === bCreatedAt ? 0 : (aCreatedAt > bCreatedAt ? -1 : 1);
}
export const oldestFirst = (a, b) => {
    let aCreatedAt = a.createdAt;
    let bCreatedAt = b.createdAt;

    if (Array.isArray(a)) {
        aCreatedAt = a[0].createdAt;
        bCreatedAt = b[0].createdAt;
    }
    return aCreatedAt === bCreatedAt ? 0 : (aCreatedAt < bCreatedAt ? -1 : 1);
}
export const unreadFirst = (a, b) => {
    let aUnread = a.unRead;
    let bUnread = b.unRead;
    if (Array.isArray(a)) {
        aUnread = a.some(a => a.unRead)
        bUnread = b.some(b => b.unRead)
    }
    return aUnread === bUnread ? 0 : (aUnread ? -1 : 1);
}
export const unreadLast = (a, b) => {
    let aUnread = a.unRead;
    let bUnread = b.unRead;
    if (Array.isArray(a)) {
        aUnread = a.some(a => a.unRead)
        bUnread = b.some(b => b.unRead)
    }
    return aUnread === bUnread ? 0 : (aUnread ? 1 : -1);
}
export const newestFirstThenUnread = (a, b) => {
    const newest = newestFirst(a, b);
    if (newest === 0) {
        return unreadFirst(a, b);
    }
    return newest;
}
export const unreadFirstThenNewest = (a, b) => {
    const unread = unreadFirst(a, b);
    if (unread === 0) {
        return newestFirst(a, b);
    }
    return unread;
}
export const unreadLastThenOldest = (a, b) => {
    const unread = unreadLast(a, b);
    if (unread === 0) {
        return oldestFirst(a, b);
    }
    return unread;
}
const isUnread = (c, editor) => !c.readBy.includes(editor);

export const filterComments = ({chatContext, allRouteComments, allStopComments, editor, archived = false}) => {
    console.log('Filtering comments for context:', chatContext);
    console.log('All route comments:', allRouteComments);
    
    let filteredComments = chatContext.type === 'route' ? values(allRouteComments) : chatContext.type === 'stop' ? values(allStopComments) : values(allRouteComments).concat(values(allStopComments));
    
    console.log('Initial filtered comments count:', filteredComments.length);
    
    if (chatContext.type !== 'all') {
        filteredComments = filteredComments.filter(comment => {
            const matches = comment.type === chatContext.type && comment.id === chatContext.id &&
                (!chatContext.subType || comment.subType === chatContext.subType) &&
                (!chatContext.routeId || comment.routeId === chatContext.routeId) &&
                (!chatContext.tripId || comment.tripId === chatContext.tripId) &&
                ((!chatContext.lat && !chatContext.lon) || (comment.lat === chatContext.lat && comment.lon === chatContext.lon)) &&
                (!chatContext.stopTimeId || comment.stopTimeId === chatContext.stopTimeId) &&
                (!chatContext.stopId || comment.stopId === chatContext.stopId);
            
            if (matches) {
                console.log('Comment matches filter:', comment);
            }
            
            return matches;
        })
    }
    
    console.log('After filtering, comments count:', filteredComments.length);
    
    filteredComments = filteredComments.filter(c => archived ? c.archived : !c.archived);
    filteredComments.forEach(c => c.unRead = isUnread(c, editor));
    return filteredComments
}

export default function useComments({chatContext, archived}) {
    const {allRouteComments, allStopComments, editor, setEditor} = useAppContext();//{allRouteComments: routeComments, allStopComments: stopComments, editor: defaultEditor});
    const [comments, setComments] = useState([]);
    const [unreadComments, setUnreadComments] = useState([]);
    const [groupedComments, setGroupedComments] = useState([]);
    const [unreadGroupedComments, setUnreadGroupedComments] = useState([]);

    useEffect(() => {
        console.log('useComments useEffect running with:', { chatContext, allRouteComments, allStopComments, editor, archived });
        
        if (!chatContext || (chatContext.type === 'route' && !allRouteComments) || (chatContext.type === 'stop' && !allStopComments) || (chatContext.type !== 'all' && !chatContext.id)) {
            console.log('useComments useEffect: early return due to missing context or data');
            setComments(comments => comments);
            return
        }
        // console.log('loading comments...', chatContext);
        let filteredComments = filterComments({chatContext, allRouteComments, allStopComments, editor, archived});
        // console.log('filteredComments', filteredComments);
        setComments(filteredComments);
        const unread = filteredComments.filter(comment => !comment.readBy?.includes(editor))
        setUnreadComments(unread);
        // group the list based on type and subType
        const grouped = groupBy(filteredComments, comment => `${comment.type}_${comment.id}`)
        setGroupedComments(map(grouped, group => group));

        const unreadGrouped = groupBy(unread, comment => `${comment.type}_${comment.id}`)
        setUnreadGroupedComments(map(unreadGrouped, group => group));
        // if (chatContext !== 'all') {
        //     const readComments = filteredComments.filter(c => !c.readBy.includes(editor)).map(c => {
        //         c.readBy = c.readBy || [];
        //         c.readBy.push(editor);
        //         return c;
        //     })
        //     if (chatContext.type === 'route') {
        //         routeCommentModelData.save(readComments).then(() => {
        //             console.log('read comments saved')
        //         });
        //     } else if (chatContext.type === 'stop') {
        //         stopCommentModelData.save(readComments).then(() => {
        //             console.log('read comments saved')
        //         });
        //     }
        // }
    }, [chatContext, allRouteComments, allStopComments, setComments, setUnreadComments, setGroupedComments, setUnreadGroupedComments, editor, archived])

    const newComment = useCallback((message) => {
        const comment = {
            message: message.trim(), 
            author: editor, 
            readBy: [editor], 
            ...chatContext
        }
        
        // Ensure the route object is properly structured for RouteCommentModelData.setId
        if (chatContext.type === 'route') {
            comment.route = {
                routeId: chatContext.route?.routeId || chatContext.routeId || chatContext.id,
                routeNumber: chatContext.route?.routeNumber || chatContext.routeId || chatContext.id,
                routeName: chatContext.route?.routeName || `Route ${chatContext.routeId || chatContext.id}`
            };
            console.log('Constructed route object for comment:', comment.route);
        }
        
        if (comment.lat) {
            comment.lat = roundToPrecision(comment.lat, LATLON_PRECISION);
        }
        if (comment.lon) {
            comment.lon = roundToPrecision(comment.lon, LATLON_PRECISION);
        }
        
        console.log('Saving comment:', comment);
        console.log('Comment route object:', comment.route);
        console.log('ChatContext route object:', chatContext.route);
        console.log('ChatContext type:', chatContext.type);
        console.log('ChatContext id:', chatContext.id);
        
        if (chatContext.type === 'route') {
            routeCommentModelData.save(comment).then((savedComment) => {
                console.log('Route comment saved successfully:', savedComment);
                console.log('Current allRouteComments after save:', allRouteComments);
            }).catch((error) => {
                console.error('Error saving route comment:', error);
            });
        } else if (chatContext.type === 'stop') {
            stopCommentModelData.save(comment).then((savedComment) => {
                console.log('Stop comment saved successfully:', savedComment);
                console.log('Current allStopComments after save:', allStopComments);
            }).catch((error) => {
                console.error('Error saving stop comment:', error);
            });
        }

    }, [editor, chatContext]);
    return {comments, groupedComments, newComment, unreadComments, unreadGroupedComments, editor, setEditor};
}